import { render, staticRenderFns } from "./PurchaseGlobalFilter.vue?vue&type=template&id=8bba1f4e&scoped=true&lang=html&"
import script from "./PurchaseGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./PurchaseGlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bba1f4e",
  null
  
)

export default component.exports